import { uiText } from '../i18n/uiText';
import { formatStatus } from './formatters';

export const assessmentState = state => ({draft:uiText("Черновик"),submitted:uiText("На проверке"),confirmed:uiText("Проверка зафиксирована")}[state] || state || uiText("Статус не указан"));
export function historyDate(value) {
  if (!value) return uiText("Дата не указана");
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? uiText("Дата не указана") : date.toLocaleDateString('ru-RU', {timeZone:'Europe/Moscow'});
}
export function companyTimeline(audits, assessments, methods) {
  const byMethod = new Map(methods.map(m => [m.id,m]));
  return [
    ...audits.map(a => ({key:`audit-${a.id}`,kind:'audit',id:a.id,title:a.title,date:a.completed_date || a.scheduled_date,
      dateLabel:a.completed_date ? uiText("Завершён") : uiText("Плановая дата"), status:formatStatus(a.status,'audit'),
      detail:[a.audit_type,a.auditor_name].filter(Boolean).join(' · '),index:a.compliance_index,indexLabel:a.compliance_label,
      counts:[a.critical_count,a.significant_count,a.minor_count]})),
    ...assessments.map(a => { const m=byMethod.get(a.methodology_id); return {key:`assessment-${a.id}`,kind:'assessment',id:a.id,
      title:uiText("Оценка №{v0} · {v1}", {v0: (a.id), v1: (a.scope_title || a.scope_key)}),date:a.submitted_at || a.created_at,
      dateLabel:a.submitted_at ? uiText("Передана на проверку") : uiText("Создана"),status:assessmentState(a.state),
      detail:m ? uiText("{v0} · версия {v1} · область {v2}", {v0: (m.title), v1: (m.version), v2: (a.scope_key)}) : uiText("Методология №{v0} · область {v1}", {v0: (a.methodology_id), v1: (a.scope_key)})}; }),
  ].sort((a,b) => (Date.parse(b.date)||0)-(Date.parse(a.date)||0) || a.key.localeCompare(b.key));
}
// Never infer organization membership from a name or from an issue's author.
export function companyOpenIssues(issues, audits) {
  const ids=new Set(audits.map(a=>a.id));
  return issues.filter(i=>ids.has(i.audit_id) && !['closed','verified'].includes(i.status));
}
